import { render, staticRenderFns } from "./selectcurrency.vue?vue&type=template&id=8b6f7472&"
import script from "./selectcurrency.js?vue&type=script&lang=js&"
export * from "./selectcurrency.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b6f7472')) {
      api.createRecord('8b6f7472', component.options)
    } else {
      api.reload('8b6f7472', component.options)
    }
    module.hot.accept("./selectcurrency.vue?vue&type=template&id=8b6f7472&", function () {
      api.rerender('8b6f7472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectcurrency.vue"
export default component.exports